/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'

import LocationIcon from '@offerzen/zenicon/LocationIcon'
import BuildingIcon from '@offerzen/zenicon/BuildingIcon'
import ComputerIcon from '@offerzen/zenicon/ComputerIcon'
import IconList, { SimpleItem } from '../../../elements/IconList'
import Subheading from '../../../typography/Subheading'
import SmallText from '../../../typography/SmallText'

import styles from './styles'

const PreferredLocations = ({ currentLocation, preferredCountries, prefersRemote }) => (
  <div>
    <IconList theme="light" size="medium">
      {Boolean(currentLocation) && (
        <SimpleItem icon={LocationIcon}>
          <Subheading className={styles.heading}>
            <strong>Based in {currentLocation}</strong>
          </Subheading>
        </SimpleItem>
      )}

      {Boolean(preferredCountries && preferredCountries.length > 0) && (
        <SimpleItem className={styles.list} icon={BuildingIcon}>
          <Subheading className={styles.heading}>
            <strong> Wants to work in:</strong>
          </Subheading>
        </SimpleItem>
      )}

      {Boolean(preferredCountries && preferredCountries.length > 0) && (
        <ul className={styles.cityList}>
          {preferredCountries.map(country => (
            <li className={styles.cityItem} key={country.id}>
              <strong>{country.name}: </strong>
              {country.cities.map((city, i) => (
                <React.Fragment key={i}>
                  <span>{city.name}</span>
                  {city.suburbs.length > 0 ? <>{` (${city.suburbs.join(', ')})`}</> : null}
                  {i < country.cities.length - 1 ? <>{', '}</> : null}
                </React.Fragment>
              ))}
            </li>
          ))}
        </ul>
      )}

      {Boolean(prefersRemote) && (
        <SimpleItem className={styles.list} icon={ComputerIcon}>
          <Subheading className={styles.heading}>
            <strong className={styles.remoteItem}>Wants to work remotely</strong>
          </Subheading>
        </SimpleItem>
      )}
    </IconList>
    {Boolean(!currentLocation && !preferredCountries && !prefersRemote) && (
      <SmallText>
        <em>No information provided</em>
      </SmallText>
    )}
  </div>
)

const { string, arrayOf, shape, bool } = PropTypes
PreferredLocations.propTypes = {
  currentLocation: string,
  preferredCountries: arrayOf(
    shape({
      id: string,
      name: string,
      suburbs: arrayOf(string),
    }),
  ),
  prefersRemote: bool,
}

export default PreferredLocations
